import React, { Component } from "react";
import { Row, Container, Col, CardTitle, Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { Field, reduxForm, formValueSelector } from "redux-form";
import {
  searchableSelect,
  renderSelectField,
  renderText,
  focusOnError,
} from "../layout/FormInputs";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import {
  maxLength70,
  minLength5,
  maxLength25,
  required,
  email,
  checkForNull,
} from "../../helper/validation";
import { MESSAGES } from "../../config/message";
import { Loader } from "../common/Loader";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { getAllShutterDesignDataList, filterShutterDesignData } from "../../actions/DesignMaster";
import NoContentFound from '../common/NoContentFound';
import { CONSTANT } from '../../helper/AllConastant';
import { convertDate } from "../../helper";
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';
const gridOptions = {};

const selector = formValueSelector('GridListing');

function enumFormatter(cell, row, enumObject) {
  return enumObject[cell];
}

const manufacturingMaterialOption = [
  { Text: "Carbon Steel", Value: 0 },
  { Text: "Stainless Steel 304/316", Value: 1 },
  { Text: "Stainless Steel 304L/316L", Value: 2 },
  { Text: "Duplex SS", Value: 3 },
  { Text: "Super Duplex SS", Value: 4 },
  { Text: "Aluminium", Value: 5 },


  { Text: 'CI FG-260', Value: 6 },
  { Text: 'CI CLASS B / CI FG-220', Value: 7 },
  { Text: 'CI FG-200', Value: 8 },
  { Text: 'CI WITH 2% NI', Value: 9 },
  { Text: 'DI ASTM A536 60-42-10', Value: 10 },
  { Text: 'DI ASTM A536 70-50-05', Value: 11 },
  { Text: 'NI RISIST-TYPE 1 -14-18', Value: 12 },
  { Text: 'NI RISIST-TYPE 2 -18-22', Value: 13 }
];

const SeriesOfferedOption = [

  { Text: 'A-101- FLAT BACK FRAME DESIGN', Value: 'A-101- FLAT BACK FRAME DESIGN', Key: '1' },
  { Text: 'A-102- SECTIONAL FRAME DESIGN', Value: 'A-102- SECTIONAL FRAME DESIGN', Key: '1' },
  { Text: 'A-103- INTEGRAL FRAME DESIGN', Value: 'A-103- INTEGRAL FRAME DESIGN', Key: '1' },
  { Text: 'A-104- UNIVERSAL FRAME DESIGN', Value: 'A-104- UNIVERSAL FRAME DESIGN', Key: '1' },
  { Text: 'A-111', Value: 'A-111', Key: '1' },
  { Text: 'A-112', Value: 'A-112', Key: '1' },
  { Text: 'A-113', Value: 'A-113', Key: '1' },
  { Text: 'A-113-B', Value: 'A-113-B', Key: '1' },
  { Text: 'A-114', Value: 'A-114', Key: '1' },
  { Text: 'A-121', Value: 'A-121', Key: '1' },



  { Text: 'A-201-202-203 CAST IRON OPEN CHANNEL', Value: 'A-201-202-203 CAST IRON OPEN CHANNEL', Key: '2' },
  // { Text: "A-211", Value: "A-211", Key: '2' },
  // { Text: "A-212", Value: "A-212", Key: '2' },
  // { Text: "A-213", Value: "A-213", Key: '2' },
  // { Text: "A-221", Value: "A-221", Key: '2' },
  // { Text: "A-222", Value: "A-222", Key: '2' },
  // { Text: "A-223", Value: "A-223", Key: '2' },
  { Text: 'A-211 / 212 / 213', Value: 'A-211 / 212 / 213', Key: '2' },
  { Text: 'A-221 / 222 / 223', Value: 'A-221 / 222 / 223', Key: '2' },
  { Text: 'A-301 CAST IRON WEIR GATE', Value: 'A-301 CAST IRON WEIR GATE', Key: '3' },
  { Text: 'A-311', Value: 'A-311', Key: '3' },
  { Text: 'A-321', Value: 'A-321', Key: '3' },

  // { Text: 'A-113/A-113-B/A-114', Value: 'A-113/A-113-B/A-114' },
  // { Text: 'A-211/212/213 & A-221/222/223', Value: 'A-211/212/213 & A-221/222/223' },
  // { Text: 'A-311 & 321', Value: 'A-311 & 321' },



];


const applicableStandardDataArray = [
  { Text: 'AWWA-C560', Value: 'AWWA-C560' },
  { Text: 'AWWA-C561', Value: 'AWWA-C561' },
  { Text: 'BS-7775', Value: 'BS-7775' },
  { Text: 'IS-5620', Value: 'IS-5620' },
  { Text: 'IS-13349', Value: 'IS-13349' }
]

const stageOptions = [
  { Text: "Tender", Value: "Tender" },
  { Text: "Post Order Design", Value: "Post Order Design" },
];

class GridListing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoader: false,
      isSubmitted: false,
      isEditFlag: false,
      ShutterId: "",
      tableData: [],
      selectedData: '',
      modal: false,
      gridApi: null,
      gridColumnApi: null,
      rowData: null,
    };
  }

  componentDidMount() {
    this.getShutterData();
  }

  getShutterData = () => {
    this.setState({ isLoader: true });

    this.props.getAllShutterDesignDataList((res) => {
      if (res && res.status == 204) {
        this.setState({ tableData: [], isLoader: false });
      } else if (res && res.data && res.data.Data) {
        let Data = res.data.Data;
        this.setState({ tableData: Data, isLoader: false });
      } else {
        this.setState({ isLoader: false, tableData: [] });
      }
    });
  };

  resetFilter = () => {
    const { reset } = this.props;
    reset();
    this.getShutterData();
  };

  /**
   * @method handleManufacturingMaterial
   * @description Handle reference documents
   */
  handleManufacturingMaterial = (e) => {
    const value = e.target.value;
  };

  /**
   * @method handleSeriesOffered
   * @description Handle offered series
   */
  handleSeriesOffered = (e) => {
    const value = e.target.value;
  };

  /**
   * @method editItemDetails
   * @description confirm edit item
   */
  editItemDetails = (Id, dataObj) => {
    let data = {
      isEditFlag: true,
      ShutterId: Id,
    };

    if (dataObj.IsPostCreated) {
      this.setState({ modal: true, selectedData: data })
    } else {
      this.props.shutterDetail(data);
    }
  };

  /**
   * @method deleteItem
   * @description confirm delete Department
   */
  deleteItem = (Id) => {
    const toastrConfirmOptions = {
      onOk: () => {
        this.confirmDeleteItem(Id);
      },
      onCancel: () => { },
    };
    return toastr.confirm(
      `${MESSAGES.SHUTTER_DESIGN_DELETE_ALERT}`,
      toastrConfirmOptions
    );
  };

  /**
   * @method confirmDeleteItem
   * @description confirm delete Department item
   */
  confirmDeleteItem = (Id) => {
    // this.props.deleteDepartmentAPI(Id, (res) => {
    //   if (res && res.data && res.data.Result === true) {
    //     toastr.success(MESSAGES.DELETE_DEPARTMENT_SUCCESSFULLY);
    //     this.getDepartmentListData();
    //   } else if (res.data.Result === false && res.statusText == "Found") {
    //     toastr.warning(res.data.Message)
    //   }
    // });
  };

  /**
   * @method indexFormatter
   * @description Renders serial number
   */
  indexFormatter = (props) => {

    let currentPage = Number(this.gridApi.paginationGetCurrentPage()) + 1;
    let sizePerPage = document.getElementById('page-size').value;

    let serialNumber = "";
    if (currentPage == 1) {
      serialNumber = props.rowIndex + 1;
    } else {
      serialNumber = props.rowIndex + 1 + sizePerPage * (currentPage - 1);
    }
    return serialNumber;
  };

  generateReport = (cell, dataObj) => {
    this.props.showReportTab(true, dataObj);
    setTimeout(() => this.props.toggle("6"), 1000);
  };

  viewDesign = (cell, dataObj) => {
    this.props.viewDesign(true, dataObj);
    setTimeout(() => this.props.toggle("2"), 1000);
  }

  // /**
  //  * @method buttonFormatter
  //  * @description Renders buttons
  //  */
  // buttonFormatter = (cell, row, enumObject, rowIndex) => {
  //   return (
  //     <>
  //       <button
  //         type={"button"}
  //         className="mr5 Edit"
  //         onClick={() => this.editItemDetails(cell)}
  //       />
  //       {/* {<button type={'button'} className="mr5" onClick={() => this.generateReport(cell)} >Report</button>} */}
  //     </>
  //   );
  // };

  gateSeries = () => {
    return (
      <>
        Gate <br /> Series
      </>
    );
  };

  seatingHead = () => {
    return (
      <>
        Seating <br /> Head <br /> (-1/+2)
      </>
    );
  };

  unSeatingHead = () => {
    return (
      <>
        Unseating <br /> Head <br /> (-1/+2)
      </>
    );
  };

  clpl = () => {
    return (
      <>
        CL-PL <br /> (-3/+3)
      </>
    );
  };

  stemDia = () => {
    return (
      <>
        Stem <br /> Dia
      </>
    );
  };

  /**
   * @method weightFormatter
   * @description Renders weight
   */
  weightFormatter = (cell, row, enumObject, rowIndex) => {
    return cell ? cell.toFixed(2) : 0;
  };


  // /**
  //  * Submit the login form
  //  * @param values
  //  */
  // onSubmit(values) {
  //   let SelectedMaterialType =
  //     values.SelectedMaterialType != undefined
  //       ? values.SelectedMaterialType
  //       : null;
  //   this.setState({ isLoader: true });

  //   let MaterialTypeId = "";
  //   if (
  //     manufacturingMaterialOption &&
  //     manufacturingMaterialOption[0].Value == SelectedMaterialType
  //   ) {
  //     MaterialTypeId = manufacturingMaterialOption[0].Text;
  //   } else if (
  //     manufacturingMaterialOption &&
  //     manufacturingMaterialOption[1].Value == SelectedMaterialType
  //   ) {
  //     MaterialTypeId = manufacturingMaterialOption[1].Text;
  //   } else if (
  //     manufacturingMaterialOption &&
  //     manufacturingMaterialOption[2].Value == SelectedMaterialType
  //   ) {
  //     MaterialTypeId = manufacturingMaterialOption[2].Text;
  //   } else if (
  //     manufacturingMaterialOption &&
  //     manufacturingMaterialOption[3].Value == SelectedMaterialType
  //   ) {
  //     MaterialTypeId = manufacturingMaterialOption[3].Text;
  //   } else if (
  //     manufacturingMaterialOption &&
  //     manufacturingMaterialOption[4].Value == SelectedMaterialType
  //   ) {
  //     MaterialTypeId = manufacturingMaterialOption[4].Text;
  //   } else if (
  //     manufacturingMaterialOption &&
  //     manufacturingMaterialOption[5].Value == SelectedMaterialType
  //   ) {
  //     MaterialTypeId = manufacturingMaterialOption[5].Text;
  //   } else if (
  //     manufacturingMaterialOption &&
  //     manufacturingMaterialOption[6].Value == SelectedMaterialType
  //   ) {
  //     MaterialTypeId = manufacturingMaterialOption[6].Text;
  //   } else if (
  //     manufacturingMaterialOption &&
  //     manufacturingMaterialOption[7].Value == SelectedMaterialType
  //   ) {
  //     MaterialTypeId = manufacturingMaterialOption[7].Text;
  //   }

  /**
  * @method buttonFormatter
  * @description Renders buttons
  */
  buttonFormatter = (props) => {

    const cell = props.valueFormatted ? props.valueFormatted : props.value;
    const row = props.valueFormatted ? props.valueFormatted : props.data;

    return (
      <>
        <button type={'button'} className="mr5 Edit" onClick={() => this.editItemDetails(cell, row)} />{' '}
        {/* {row.IsPostCreated && <button type={'button'} className="mr5 View" onClick={() => this.generateReport(cell, row)} ></button>} */}
        <button type={'button'} className="mr5 Report" onClick={() => this.generateReport(cell, row)} color="info"></button> {' '}
        {/* {row.IsPostCreated && <Button type={'button'} className="mr5" onClick={() => this.generateReport(cell, row)} color="info">Report</Button>} */}
        <button type={'button'} className="mr5 View" color="info" onClick={() => this.viewDesign(cell, row)}></button> {' '}
      </>
    )
  }

  /**
      * @method nullHandler
      * @description Renders buttons
      */
  nullHandler = (props) => {
    const cell = props.valueFormatted ? props.valueFormatted : props.value;

    return cell === null ? '-' : cell
  }

  /**
  * @method dateFormatter
  * @description Renders date
  */
  dateFormatter = (props) => {
    const cell = props.valueFormatted ? props.valueFormatted : props.value;

    return cell === null ? '-' : convertDate(cell);
  }

  gateSeries = () => {
    return <>Gate <br /> Series</>
  }

  seatingHead = () => {
    return <>Seating <br /> Head <br /> (-1/+2)</>
  }

  unSeatingHead = () => {
    return <>Unseating <br /> Head  <br /> (-1/+2)</>
  }

  clpl = () => {
    return <>CL-PL <br /> (-3/+3)</>
  }

  stemDia = () => {
    return <>Stem <br /> Dia</>
  }

  /**
  * @method weightFormatter
  * @description Renders weight
  */
  weightFormatter = (cell, row, enumObject, rowIndex) => {
    return cell ? cell.toFixed(2) : 0;
  }

  /**
  * Submit the login form
  * @param values
  */
  onSubmit(values) {

    let SelectedMaterialType = (values.SelectedMaterialType != undefined) ? values.SelectedMaterialType : null;

    this.setState({ isLoader: true })

    let MaterialTypeId = '';
    if (SelectedMaterialType) {
      if (manufacturingMaterialOption && manufacturingMaterialOption[0].Value == SelectedMaterialType) {
        MaterialTypeId = manufacturingMaterialOption[0].Text;
      } else if (manufacturingMaterialOption && manufacturingMaterialOption[1].Value == SelectedMaterialType) {
        MaterialTypeId = manufacturingMaterialOption[1].Text;
      } else if (manufacturingMaterialOption && manufacturingMaterialOption[2].Value == SelectedMaterialType) {
        MaterialTypeId = manufacturingMaterialOption[2].Text;
      } else if (manufacturingMaterialOption && manufacturingMaterialOption[3].Value == SelectedMaterialType) {
        MaterialTypeId = manufacturingMaterialOption[3].Text;
      } else if (manufacturingMaterialOption && manufacturingMaterialOption[4].Value == SelectedMaterialType) {
        MaterialTypeId = manufacturingMaterialOption[4].Text;
      } else if (manufacturingMaterialOption && manufacturingMaterialOption[5].Value == SelectedMaterialType) {
        MaterialTypeId = manufacturingMaterialOption[5].Text;
      } else if (manufacturingMaterialOption && manufacturingMaterialOption[6].Value == SelectedMaterialType) {
        MaterialTypeId = manufacturingMaterialOption[6].Text;
      } else if (manufacturingMaterialOption && manufacturingMaterialOption[7].Value == SelectedMaterialType) {
        MaterialTypeId = manufacturingMaterialOption[7].Text;
      } else if (manufacturingMaterialOption && manufacturingMaterialOption[8].Value == SelectedMaterialType) {
        MaterialTypeId = manufacturingMaterialOption[8].Text;
      } else if (manufacturingMaterialOption && manufacturingMaterialOption[9].Value == SelectedMaterialType) {
        MaterialTypeId = manufacturingMaterialOption[9].Text;
      } else if (manufacturingMaterialOption && manufacturingMaterialOption[10].Value == SelectedMaterialType) {
        MaterialTypeId = manufacturingMaterialOption[10].Text;
      } else if (manufacturingMaterialOption && manufacturingMaterialOption[11].Value == SelectedMaterialType) {
        MaterialTypeId = manufacturingMaterialOption[11].Text;
      } else if (manufacturingMaterialOption && manufacturingMaterialOption[12].Value == SelectedMaterialType) {
        MaterialTypeId = manufacturingMaterialOption[12].Text;
      } else if (manufacturingMaterialOption && manufacturingMaterialOption[13].Value == SelectedMaterialType) {
        MaterialTypeId = manufacturingMaterialOption[13].Text;
      }
    }

    let filterData = {
      SelectedSeriesOffered: values.SelectedSeriesOffered != undefined ? values.SelectedSeriesOffered : '',
      SelectedMaterialType: SelectedMaterialType != null ? MaterialTypeId : '',
      SizeWidth: values.SizeWidth != undefined ? values.SizeWidth : null,
      SizeHeight: values.SizeHeight != undefined ? values.SizeHeight : null,
      SeatingHead: values.SeatingHead != undefined ? values.SeatingHead : null,
      UnseatingHead: values.UnseatingHead != undefined ? values.UnseatingHead : null,
      ClPl: values.ClPl != undefined ? values.ClPl : null,
      PIDNumber: values.PIDNumber != undefined ? values.PIDNumber : null,
      QuoteNumber: values.QuoteNumber != undefined ? values.QuoteNumber : null,
      SelectedApplicableStandard: values.SelectedApplicableStandard != undefined ? values.SelectedApplicableStandard : null,
      SelectedStage: values.Stage != undefined ? values.Stage : null
    }

    this.props.filterShutterDesignData(filterData, (res) => {

      if (res && res.status == 204) {
        this.setState({ tableData: [], isLoader: false })
      } else if (res && res.data && res.data.Data) {
        let Data = res.data.Data;
        this.setState({ tableData: Data, isLoader: false })
      } else {
        this.setState({ isLoader: false, tableData: [] })
      }
    })
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
    // this.gridApi.sizeColumnsToFit();
    this.setState({ gridApi: params.api, gridColumnApi: params.columnApi })
    params.api.paginationGoToPage(0);

    var allColumnIds = [];
    params.columnApi.getAllColumns().forEach(function (column) {
      allColumnIds.push(column.colId);
    });
    params.columnApi.autoSizeColumns(allColumnIds);
    //if resolution greater than 1920 table listing fit to 100%
    window.screen.width > 1920 && params.api.sizeColumnsToFit()
    //if resolution greater than 1920 table listing fit to 100%

    this.resetState()
  };

  onPageSizeChanged = (newPageSize) => {
    var value = document.getElementById('page-size').value;
    this.state.gridApi.paginationSetPageSize(Number(value));
  };

  onFilterTextBoxChanged(e) {
    this.state.gridApi.setQuickFilter(e.target.value);
  }

  resetState() {
    gridOptions.columnApi.resetColumnState();
    gridOptions.api.setFilterModel(null);
  }

  render() {
    const { handleSubmit, reset, pristine, submitting } = this.props;
    const { isLoader, selectedData, modal } = this.state;

    const options = {
      clearSearch: true,
      noDataText: <NoContentFound title={CONSTANT.EMPTY_DATA} />,
    };

    const defaultColDef = {
      resizable: true,
      filter: true,
      sortable: true,
    };

    const frameworkComponents = {
      totalValueRenderer: this.buttonFormatter,
      indexFormatter: this.indexFormatter,
      nullHandler: this.nullHandler,
      dateFormatter: this.dateFormatter
    };

    return (
      <div className="ag-grid-react">
        {isLoader && <Loader />}
        <Modal isOpen={modal}>
          <ModalHeader>Post Order Alert !</ModalHeader>
          <ModalBody>
            {`This order is either a Post Order or it is already converted into a Post Order. Please continue with different values of PID Number, Quote Number and Item Number in the next page.`}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={() => this.props.shutterDetail(selectedData)}>Continue</Button>{' '}
            <Button color="primary" onClick={() => this.setState({ modal: false })}>Cancel</Button>{' '}
          </ModalFooter>
        </Modal>
        <div className="shutter-design">
          <Container fluid className="cr-searchlisting-container cr-table-wrap">
            <div className="form-heading">
              <h2>Search Listing</h2>
            </div>
            <form
              noValidate
              className="form"
              onSubmit={handleSubmit(this.onSubmit.bind(this))}
            >
              <Row>
                <Col md="3">
                  <Field
                    label={`Gate Series`}
                    name={"SelectedSeriesOffered"}
                    type="text"
                    placeholder={'----- Select -----'}
                    options={SeriesOfferedOption}
                    onChange={this.handleSeriesOffered}
                    optionValue={'Value'}
                    optionLabel={'Text'}
                    component={renderSelectField}
                    className="custom-select"
                    customClassName="withoutBorderBottom"
                  />
                </Col>
                <Col md="3">
                  <Field
                    label={`Material Of Construction`}
                    name={"SelectedMaterialType"}
                    type="text"
                    placeholder={'----- Select -----'}
                    options={manufacturingMaterialOption}
                    onChange={this.handleManufacturingMaterial}
                    optionValue={'Value'}
                    optionLabel={'Text'}
                    component={renderSelectField}
                    className="custom-select"
                    customClassName="withoutBorderBottom"
                  />
                </Col>
                <Col md="3">
                  <Field
                    label={`Gate Width`}
                    name={"SizeWidth"}
                    type="number"
                    placeholder={''}
                    component={renderText}
                    className={''}
                    customClassName="withoutBorderBottom"
                  />
                </Col>
                <Col md="3">
                  <Field
                    label={`Gate Height`}
                    name={"SizeHeight"}
                    type="number"
                    placeholder={''}
                    component={renderText}
                    className={''}
                    customClassName="withoutBorderBottom"
                  />
                </Col>
                <Col md="3">
                  <Field
                    label={`Seating Head`}
                    name={"SeatingHead"}
                    type="number"
                    placeholder={''}
                    component={renderText}
                    className={''}
                    customClassName="withoutBorderBottom"
                  />
                </Col>
                <Col md="3">
                  <Field
                    label={`Unseating Head`}
                    name={"UnseatingHead"}
                    type="number"
                    placeholder={''}
                    component={renderText}
                    className={''}
                    customClassName="withoutBorderBottom"
                  />
                </Col>
                <Col md="3">
                  <Field
                    label={`CL-PL`}
                    name={"ClPl"}
                    type="number"
                    placeholder={''}
                    component={renderText}
                    className={''}
                    customClassName=" withoutBorderBottom"
                  />
                </Col>
                <Col md="3">
                  <Field
                    label={`Quote No.`}
                    name={"text"}
                    type="text"
                    placeholder={''}
                    component={renderText}
                    className={''}
                    customClassName=" withoutBorderBottom"
                  />
                </Col>
                <Col md="3">
                  <Field
                    label={`PID`}
                    name={"PIDNumber"}
                    type="text"
                    placeholder={''}
                    component={renderText}
                    className={''}
                    customClassName=" withoutBorderBottom"
                  />
                </Col>
                <Col md="3">
                  <Field
                    label={`Stage`}
                    name={"Stage"}
                    type="text"
                    placeholder={'----- Select -----'}
                    options={stageOptions}
                    optionValue={'Value'}
                    optionLabel={'Text'}
                    component={renderSelectField}
                    className=" custom-select"
                    customClassName=" withoutBorderBottom"
                  />
                </Col>
                <Col md="3">
                  <Field
                    label={`Standard`}
                    name={"SelectedApplicableStandard"}
                    optionValue={'Value'}
                    optionLabel={'Text'}
                    options={applicableStandardDataArray}
                    component={renderSelectField}
                    className="custom-select"
                    customClassName="withoutBorderBottom"
                  />
                </Col>
                <Col md="3" className={'cr-filter-buttons'}>
                  <label className={'w-100 mb-0'}>&nbsp;</label>
                  <button
                    type={'submit'}
                    disabled={false}
                    className={'btn btn-primary pull-left mr15'}>Filter</button>
                  <button
                    onClick={this.resetFilter}
                    disabled={pristine || submitting}
                    className={'cancel-btn btn pull-left mr5 mt-0'}>Reset</button>
                </Col>
              </Row>
            </form>
          </Container>
        </div>
        <hr className="mt-4" />
        <div className="cr-table-wrap">
          <Row className="mt-4 pt-4">
            <Col>
              {/* <BootstrapTable
                data={this.state.tableData}
                bordered={false}
                striped={false}
                hover={true}
                options={options}
                search
                ref={'table'}
                ignoreSinglePage
                trClassName={'userlisting-row'}
                tableHeaderClass='my-custom-class'
                pagination>
                <TableHeaderColumn dataField="Sr. No." width={'70'} dataFormat={this.indexFormatter}>{'Sr. No.'}</TableHeaderColumn>
                <TableHeaderColumn dataField="QuoteNumber" width={'110'} dataFormat={this.nullHandler} dataSort={true}>{'Quote No.'}</TableHeaderColumn>
                <TableHeaderColumn dataField="PIDNumber" width={'110'} dataFormat={this.nullHandler} dataSort={true}>{'PID'}</TableHeaderColumn>
                <TableHeaderColumn dataField="SelectedSeriesOffered" dataFormat={this.nullHandler} width={'110'} isKey={true} columnTitle dataAlign="center" dataSort={true}>{this.gateSeries()}</TableHeaderColumn>
                <TableHeaderColumn dataField="SelectedStage" dataFormat={this.nullHandler} width={'110'} dataSort={true}>{'Stage'}</TableHeaderColumn>
                <TableHeaderColumn dataField="SelectedApplicableStandard" dataFormat={this.nullHandler} width={'110'} dataSort={true}>{'Standard'}</TableHeaderColumn>
                <TableHeaderColumn dataField="SelectedMaterialType" dataFormat={this.nullHandler} width={'100'} columnTitle dataAlign="center" dataSort={true}>MOC</TableHeaderColumn>
                <TableHeaderColumn dataField="SizeWidth" width={'75'} dataFormat={this.nullHandler} columnTitle dataAlign="center" dataSort={true}>Width</TableHeaderColumn>
                <TableHeaderColumn dataField="SizeHeight" width={'80'} dataFormat={this.nullHandler} columnTitle dataAlign="center" dataSort={true}>Height</TableHeaderColumn>
                <TableHeaderColumn dataField="SeatingHead" columnTitle dataFormat={this.nullHandler} dataAlign="center" dataSort={true}>{this.seatingHead()}</TableHeaderColumn>
                <TableHeaderColumn dataField="UnseatingHead" width={'60'} dataFormat={this.nullHandler} columnTitle dataAlign="center" dataSort={true}>{this.unSeatingHead()}</TableHeaderColumn>
                <TableHeaderColumn dataField="ClPl" width={'80'} columnTitle dataAlign="center" dataSort={true}>{this.clpl()}</TableHeaderColumn>
                <TableHeaderColumn dataField="SelectedActuation" width={'100'} dataFormat={this.nullHandler} columnTitle dataAlign="center" dataSort={true}>Operator</TableHeaderColumn>
                <TableHeaderColumn dataField="SelectedStemDiameter" width={'110'} dataFormat={this.nullHandler} columnTitle dataAlign="center" dataSort={true}>{this.stemDia()}</TableHeaderColumn>
                <TableHeaderColumn dataField="WeightOfDoorOrShutter" width={'110'} dataFormat={this.nullHandler} columnTitle dataFormat={this.weightFormatter} dataAlign="center" dataSort={true}>Shutter Wt.(kg)</TableHeaderColumn>
                <TableHeaderColumn dataField="UserName" dataFormat={this.nullHandler} width={'110'} dataSort={true}>{'User Name'}</TableHeaderColumn>
                <TableHeaderColumn dataField="ModifiedDate" dataFormat={this.dateFormatter} width={'230'} dataSort={true}>{'Date and Time'}</TableHeaderColumn>
                <TableHeaderColumn dataField="ShutterDesignCalculationId" width={'200'} dataFormat={this.buttonFormatter}>Actions</TableHeaderColumn>
              </BootstrapTable> */}

              <div className="ag-grid-wrapper" style={{ width: '100%', height: '100%' }}>
                <div className="ag-grid-header row">
                  <div className="col-md-6">
                    <input type="text" className="form-control table-search" id="filter-text-box" placeholder="Search" onChange={(e) => this.onFilterTextBoxChanged(e)} />
                  </div>
                  <div className="col-md-6 text-right">
                    <button type="button" className="user-btn" title="Reset Grid" onClick={() => this.resetState()}>
                      <div className="">Refresh</div>
                    </button>
                  </div>
                </div>

                <div className="ag-theme-material" >
                  <AgGridReact
                    style={{ height: '100%', width: '100%' }}
                    defaultColDef={defaultColDef}
                    domLayout='autoHeight'
                    // columnDefs={c}
                    rowData={this.state.tableData}
                    pagination={true}
                    paginationPageSize={10}
                    onGridReady={this.onGridReady}
                    gridOptions={gridOptions}
                    loadingOverlayComponent={'customLoadingOverlay'}
                    noRowsOverlayComponent={'customNoRowsOverlay'}
                    noRowsOverlayComponentParams={{
                      title: CONSTANT.EMPTY_DATA,
                    }}
                    frameworkComponents={frameworkComponents}
                    floatingFilter={true}
                  >
                    <AgGridColumn field="Sr. No." headerName="Sr. No." cellRenderer={'indexFormatter'}></AgGridColumn>
                    <AgGridColumn field="QuoteNumber" headerName="Quote No." cellRenderer={'nullHandler'}></AgGridColumn>
                    <AgGridColumn field="PIDNumber" headerName="PID" cellRenderer={'nullHandler'}></AgGridColumn>
                    <AgGridColumn field="SelectedSeriesOffered" headerName="Gate Series" cellRenderer={'nullHandler'}></AgGridColumn>
                    <AgGridColumn field="SelectedStage" headerName="Stage" cellRenderer={'nullHandler'}></AgGridColumn>
                    <AgGridColumn field="SelectedApplicableStandard" headerName="Standard" cellRenderer={'nullHandler'}></AgGridColumn>
                    <AgGridColumn field="SelectedMaterialType" headerName="MOC" cellRenderer={'nullHandler'}></AgGridColumn>
                    <AgGridColumn field="SizeWidth" headerName="Width" cellRenderer={'nullHandler'}></AgGridColumn>
                    <AgGridColumn field="SizeHeight" headerName="Height" cellRenderer={'nullHandler'}></AgGridColumn>
                    <AgGridColumn field="SeatingHead" headerName="Seating Head (-1/+2)" cellRenderer={'nullHandler'}></AgGridColumn>
                    <AgGridColumn field="UnseatingHead" headerName="Unseating Head (-1/+2)" cellRenderer={'nullHandler'}></AgGridColumn>
                    <AgGridColumn field="ClPl" headerName="CL-PL (-3/+3)"></AgGridColumn>
                    <AgGridColumn field="SelectedActuation" headerName="Operator" cellRenderer={'nullHandler'}></AgGridColumn>
                    <AgGridColumn field="SelectedStemDiameter" headerName="Stem Dia" cellRenderer={'nullHandler'}></AgGridColumn>
                    <AgGridColumn field="WeightOfDoorOrShutter" headerName="Shutter Wt.(kg)" cellRenderer={'nullHandler'}></AgGridColumn>
                    <AgGridColumn field="UserName" headerName="User Name" cellRenderer={'nullHandler'}></AgGridColumn>
                    <AgGridColumn field="ModifiedDate" headerName="Date and Time" cellRenderer={'dateFormatter'}></AgGridColumn>
                    <AgGridColumn field="ShutterDesignCalculationId" pinned="right" width={155} headerName="Actions" type="rightAligned" cellRenderer={'totalValueRenderer'}></AgGridColumn>
                  </AgGridReact>
                  <div className="paging-container d-inline-block float-right">
                    <select className="form-control paging-dropdown" onChange={(e) => this.onPageSizeChanged(e.target.value)} id="page-size">
                      <option value="10" selected={true}>10</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

/**
 * Form validations
 * @param values
 * @returns {{}}
 */
const validate = (values) => {
  let errors = {};

  return errors;
};

/**
 * @method mapStateToProps
 * @description return state to component as props
 * @param {*} state
 */
function mapStateToProps(state) {
  const { auth } = state;

  const { technologyList, loading } = auth;
  return { technologyList, loading };
}

/**
 * @method connect
 * @description connect with redux
 * @param {function} mapStateToProps
 * @param {function} mapDispatchToProps
 */
export default connect(mapStateToProps, {
  getAllShutterDesignDataList,
  filterShutterDesignData,
})(
  reduxForm({
    form: "GridListing",
    onSubmitFail: (errors) => {
      focusOnError(errors);
    },
    enableReinitialize: true,
  })(GridListing)
);
